import styled from 'styled-components';

const Top = styled.div`
  background: radial-gradient(circle at 50% 0, #ac0c26, #c8102e);
  padding: 2rem 0rem 23rem;
  ${Styles.mobile`
    padding: 2rem 0rem 15rem;
  `}
  ${Styles.mobileSmall`
    padding: 2rem 0rem 10rem;
  `}
`;

export default Top;
